import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument]) {
        channels: entries(section: "channels", siteId: $siteId) {
            id
            slug
            title
            ... on channels_Entry {
                channelType
                sessionTypeID
                channelStatus
                channelDisplay
                altVideoLinksPage: page {
                    slug
                }
                videoLinksLevel
                eventListOrganization
                color1
                sponsoredBy: string3
                currentlyAvailableVersions
                brightcoveLiveStreamMediaId
                brightcovePlayerIdLive
                brightcovePlayerIdOnDemand
                isSimulive
                currentSimuliveEmbedSource
                currentPigeonholeSession
                guardLiveVersion
                guardOnDemandVersion
                specialAccessGroups: string
                adsLivePage {
                    ... on adsLivePageBlock_Entry {
                        leaderboardAd
                        sideAd1
                        sideAd2
                    }
                }
                adsOnDemandPage {
                    ... on adsOnDemandPageBlock_Entry {
                        leaderboardAd
                        sideAd1
                        sideAd2
                    }
                }
                bannerImageLive {
                    url
                }
                bannerImageOndemand {
                    url
                }
                eventListThumbnail {
                    url
                }
            }
        }
    }
`
